import styled, { keyframes } from "styled-components";
import { Select } from "../Select/Select";

const chevron = encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#64748B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m4 6 4 4 4-4"/></svg>',
);

export const ContentSelect = styled(Select)<{ $isPlaceholder?: boolean }>`
  && {
    background-image: url("data:image/svg+xml,${chevron}");
    background-size: 1rem;
    background-position: right 1rem center;
    color: ${({ $isPlaceholder }) => ($isPlaceholder ? "#d1d5db" : "#0f172a")};

    &:focus {
      outline: none;
      border-color: var(--general-border, #3754e2);
    }

    option {
      color: #0f172a;
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.50);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-width: 384px;
  box-shadow: 0 12px 48px -12px rgba(15, 23, 42, 0.35);
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #CBD5E1;
`;

export const Title = styled.h2`
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  padding-left: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  padding: 4px;
  margin-right: 0.875rem;
  line-height: 0;
  cursor: pointer;
  color: #94a3b8;

  &:hover {
    color: #0f172a;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 2rem;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FieldLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  color: #0F172A;
`;

export const PreferenceGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const CheckboxLabel = styled.label<{ $highlight?: boolean }>`
  display: inline-flex;
  align-items: center;
  flex: 1;
  gap: 6px;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  color: #0F172A;
  
  input {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    accent-color: #2FB640;
  }
`;

export const ConsentWrapper = styled.div`
  border-top: 1px solid #e2e8f0;
  padding-top: 16px;
`;

export const Actions = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FeedbackMessage = styled.p<{ $variant: "success" | "error" }>`
  margin-top: 0;
  font-size: 14px;
  line-height: 1.4;
  color: ${({ $variant }) => ($variant === "success" ? "#15803d" : "#f3322b")};
`;

export const FieldErrorMessage = styled.span`
  margin-top: 4px;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #f3322b;
`;

export const SubmitRow = styled.div`
  position: relative;
  width: 100%;

  &.is-loading .styleguide {
    padding-right: 48px;
  }
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingIndicator = styled.span`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  animation: ${spin} 0.75s linear infinite;
  pointer-events: none;
  z-index: 1;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const FormMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

export const FormMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const FormMessageTitle = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: #0f172a;
  text-align: center;
  margin: 0;
  line-height: 1.5;
`;
